module.exports = __webpack_public_path__ + "static/media/my-vinos-follow-header.d0aeb320.jpg";